import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import ElectricityInfoComponent from "./electricityInfoComponent";
import { ElectricityInfoLevel } from "shared/types/electricity";
import { useCallback } from "react";

const ElectricityCheckModal = ({ isOpen, onClose, unit, building }: any) => {
  const handleClose = useCallback(async () => {
    // You might want to check for unsaved changes here and show a confirmation dialog
    onClose();
  }, [onClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="full"
      shouldBlockScroll={true}
      isDismissable={true}
      scrollBehavior="inside"
      backdrop="blur"
    >
      <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary mx-auto max-w-[calc(100%-8rem)] my-12">
        <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
          <p>{unit?.id || building?.id} - Elektriciteit</p>
        </ModalHeader>
        <ModalBody className="px-0">
          <ElectricityInfoComponent
            handleCloseParent={handleClose}
            electricityInfo={
              unit
                ? {
                    ...unit?.electricityInfo,
                    level: ElectricityInfoLevel.UNIT,
                    unitId: unit?.id,
                  }
                : {
                    ...building?.electricityInfo,
                    level: ElectricityInfoLevel.BUILDING,
                    buildingId: building?.id,
                  }
            }
            unit={unit}
            building={building}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ElectricityCheckModal;
